exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-message[data-v-62e9ba1a] {\n  text-align: center;\n}", ""]);

// exports
